import { clsx } from 'clsx';

type Size = 'sm' | 'md' | 'lg';

const SIZE: Record<Size, string> = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
  lg: 'h-14 w-14 text-base',
};

export function Avatar({
  name,
  src,
  size = 'md',
  className,
}: {
  name: string;
  src?: string;
  size?: Size;
  className?: string;
}) {
  const initial = name.trim().charAt(0).toUpperCase() || '?';
  return src ? (
    <img
      src={src}
      alt={name}
      className={clsx('rounded-full object-cover', SIZE[size], className)}
    />
  ) : (
    <span
      className={clsx(
        'inline-flex items-center justify-center rounded-full bg-sage-lt font-bold text-sage-dk',
        SIZE[size],
        className,
      )}
    >
      {initial}
    </span>
  );
}
